import styled from '@emotion/styled'
import { motion } from 'framer-motion'

export const Container = styled.div`
  position: relative;
  width: 270px;
`

export const Title = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: normal;
  color: #2e196b;
`

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const IconWrapper = styled(motion.span)`
  transition: transform 0.1s;
  width: 20px;
`

export const Button = styled.button<{ isDropdownOpen: boolean }>`
  display: flex;
  height: 35px;
  align-items: center;
  cursor: pointer;
  border: 1px solid #e0dceb;
  ${props => props.isDropdownOpen && 'border-bottom: 1px solid transparent;'}
  outline: none;
  background-color: #faf9ff;
  overflow: hidden;
  position: relative;
  width: 100%;
  border-radius: ${props => (props.isDropdownOpen ? '4px 4px 0 0' : '4px')};
`

export const ContentContainer = styled(motion.div)`
  background-color: #faf9ff;
  position: absolute;
  border: 1px solid #e0dceb;
  border-top: none;
  border-radius: 0 0 4px 4px;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 2;
`

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px;
`

export const ClassificationsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
`

export const NoSourceUrlContainer = styled.div`
  text-align: center;
  padding: 10px 25px;
  padding-bottom: 35px;
`

export const NoSourceUrlText = styled.p`
  font-weight: 700;
  font-size: 15pxl
  color: #30505A;
  margin-bottom: 0;
  text-align: left;
`

export const ToggleAiContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  text-align: center;
  padding-bottom: 35px;
`

export const buttonSxProps = isClassificationSelected => ({
  fontWeight: 700,
  fontSize: 12,
  border: '1px solid #DDE1E5',
  textTransform: 'Capitalize',
  padding: '4px 11px',
  color: isClassificationSelected ? '#FFFFFF' : '#ADA2CA',
  boxShadow: '1px 1px 3px 0px #7F52FF33',
  backgroundColor: isClassificationSelected ? '#7F52FF' : '#FFFFFF',
  '&:hover': {
    backgroundColor: isClassificationSelected ? '#7F52FF' : '#F4F4F4',
    borderColor: '#7F52FF',
  },
})

export const toggleAiButtonSxProps = isEnabled => ({
  fontWeight: 700,
  fontSize: 12,
  border: '1px solid transparent',
  textTransform: 'Capitalize',
  color: '#FFFFFF',
  padding: '4px 11px',
  boxShadow: '1px 1px 3px 0px #7F52FF33',
  backgroundColor: isEnabled ? '#0091FF' : '#7F52FF',
  '&:hover': {
    backgroundColor: isEnabled ? '#0091FF' : '#7F52FF',
    borderColor: 'transparent',
  },
})
